// CSS
import './Login.css';
// React hooks
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// External hooks/components
import { SignIn, useAuth as useClerkAuth } from '@clerk/react';
// Media assets
import CloseIcon from '../../assets/StandardIcons/close-icon-black.svg';


// =====
// Login – represents the '/login' Landing page.
// =====
function Login(){

    // destructure global context
    const { isSignedIn } = useClerkAuth();

    // init hooks
    const navigate = useNavigate();
    const location = useLocation();

    // =======================
    // Behavior: Auto-redirect – automatically re-direct all already isSignedIn @Clerk Users.
    // =======================
    useEffect(() => {

        // immediately send back to '/' [home] page.
        if (isSignedIn) { navigate('../'); };
    
    }, [isSignedIn]);

    // ========================
    // handleCloseButtonClick()
    // ========================
    const handleCloseButtonClick = () => {
        navigate(location.state?.from || '/');
    };
    

    // JSX Component
    return(
        <div className='LoginPage'>
            
            {/* Aesthetic background */}
            <div className='login-page-aesthetic-bg'></div>
            
            {/* Close button */}
            <img src={ CloseIcon } className='login-page-close-button' onClick={ () => handleCloseButtonClick() } alt='Click to return to the Skybase home page.'/>

            {/* Form content */}
            <div className='LoginPage-form-content'>

                {/* @Clerk Sign-in Form */}
                <SignIn
                    path="/login"
                    routing="path"
                    signUpUrl="/create-account"
                />

            </div>
        </div>
    );
}


// Export statement
export default Login;